import { Span } from '@sentry/tracing';

export function readFile(file: File, span: Span | undefined) {
  const s = span?.startChild({
    op: 'readFile',
  });

  return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const reader = new FileReader();
    const onError = (e) => reject(e);
    const onLoad = () => resolve(reader.result);
    const destroy = () => {
      reader.removeEventListener('load', onLoad);
      reader.removeEventListener('error', onError);
      reader.removeEventListener('loadend', destroy);
      s?.finish();
    };

    reader.addEventListener('load', onLoad);
    reader.addEventListener('error', onError);
    reader.addEventListener('loadend', destroy);

    reader.readAsArrayBuffer(file);
  });
}
